function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -533.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "PDF",
  transform: "translate(0.000000, 505.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#EC4B32",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0476222,14.2199708 C15.4519294,14.4190668 15.3678478,14.6770505 15.2435144,15.8959296 C15.1164975,17.1531325 14.6907227,19.4497476 13.87048,21.7089738 C13.0493428,23.9644611 11.8310543,26.1806901 10.7693006,27.8211294 C9.70844148,29.4625035 8.80053925,30.5290228 8.1082079,31.1450055 C7.41319309,31.7609881 6.93285466,31.9254994 6.61889044,31.9797134 C6.30760968,32.0339273 6.16628106,31.9797134 6.08219947,31.8142673 C5.99811789,31.649756 5.96859988,31.3786863 6.04105316,31.0477942 C6.11171747,30.7206411 6.28077513,30.3374045 6.76021907,29.8466748 C7.24413543,29.3540756 8.03575462,28.7511791 9.14044354,28.1912799 C10.2451325,27.6304459 11.6602077,27.1107397 12.8221436,26.7546102 C13.9840796,26.40035 14.8892984,26.207797 15.681812,26.0573066 C16.4761147,25.9058814 17.1550287,25.7983882 17.8205256,25.7423048 C18.4860224,25.6899603 19.1389964,25.6899603 19.7758697,25.7423048 C20.412743,25.7983882 21.0353045,25.9058814 21.5746789,26.0442205 C22.1113699,26.1806901 22.5657682,26.3442666 22.9620251,26.6059892 C23.3573874,26.8639728 23.6981862,27.2201024 23.8672439,27.6182945 C24.038985,28.0136824 24.038985,28.4530024 23.8967619,28.7661347 C23.7554332,29.0811364 23.470987,29.27182 23.146289,29.3830521 C22.8206965,29.4905452 22.4530631,29.5176522 22.0129765,29.3830521 C21.5746789,29.244713 21.0630335,28.9437321 20.5263425,28.5474094 C19.9887571,28.150152 19.4216536,27.6575529 18.686387,26.8920145 C17.9493314,26.1264761 17.0423236,25.0879985 16.2784335,24.0756932 C15.5145433,23.0633879 14.8892984,22.0791242 14.464418,21.2444163 C14.0413266,20.4097084 13.8141274,19.7264257 13.6298635,19.043143 C13.4455996,18.3579908 13.304271,17.6747081 13.2479185,17.0596601 C13.1915659,16.4446122 13.217506,15.8959296 13.274753,15.4575444 C13.3311056,15.0219634 13.4178706,14.6910713 13.5583047,14.4714113 C13.6996334,14.256425 13.8991035,14.1442582 14.0404321,14.0900442 C14.1817608,14.0358303 14.2676313,14.0358303 14.3517129,14.0218094 C14.4357945,14.0077886 14.5198761,13.9806816 14.6495764,14.0218094 C14.7730153,14.0610678 14.9367061,14.1657568 15.1003968,14.2723153",
  id: "Shape",
  stroke: "#FFFFFF",
  strokeWidth: 1.4,
  strokeLinejoin: "round",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#FF664E",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.cefe844b.svg";
export { ForwardRef as ReactComponent };